import React from "react";

import { STRINGS } from "../utils/string";

export default function ActionItemLawFirm({ item }) {
  return (
    <>
      <span className="font-bold">
        {item?.name || item?.onCaseName || STRINGS.NO_LAW_FIRM_NAME}
      </span>
      <div className="mb-1 truncate text-ellipsis">
        <span className="font-bold">{STRINGS.CLIENT}: </span>
        {item?.clientName ? item?.clientName : STRINGS.NO_CLIENT_NAME}
      </div>
    </>
  );
}
